Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}




var filterInput=exports.filterInput=function filterInput(model){return function(input){
var fields=Object.keys(model.fields);
var inputFields=Object.keys(input);




var allowedFields=inputFields.
map(function(e){
var isIn=fields.includes(e);
if(!isIn){






return;
}

return e;
}).
filter(function(e){return e!==undefined;});

return allowedFields.reduce(
function(obj,f){return _extends({},
obj,_defineProperty({},
f,input[f]));},

{});

};};